import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { NetworkStatusService } from './services/network-status.service';

@Component({
    selector: 'mea-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
    isProduction = environment.production;
    isNetworkOnline = true;

    constructor(private networkService: NetworkStatusService) {
        this.networkService.isOnline$.subscribe(isOnline => {
            this.isNetworkOnline = isOnline;
        });
    }

    toggleNetworkStatus() {
        this.networkService.simulateNetworkStatus(!this.isNetworkOnline);
    }
}
